import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import VueFeather from 'vue-feather';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const { version } = require('../package.json');
// @ts-ignore
import { ElementTiptapPlugin } from 'element-tiptap';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-tiptap/lib/index.css';
import './styles/theme.scss';
import * as firebase from 'firebase/app';
import 'firebase/analytics';
import 'firebase/remote-config';
import 'firebase/performance';

// firebase init - add your own config here
const firebaseConfig = {
  apiKey: 'AIzaSyC1CmsMH8YFQg0zChpx4-3Cf3EjurrFOVY',
  authDomain: 'markdown-myapp.firebaseapp.com',
  databaseURL: 'https://markdown-myapp.firebaseio.com',
  projectId: 'markdown-myapp',
  storageBucket: 'markdown-myapp.appspot.com',
  messagingSenderId: '381992533531',
  appId: '1:381992533531:web:c0e84936f5804c306542be',
  measurementId: 'G-C6SXPXRN9D',
};

firebase.initializeApp(firebaseConfig);

if (process.env.NODE_ENV === 'production') {
  // firebase.analytics();
  firebase.performance();
  // C6SXPXRN9D
  document.write(`
  <!-- Global site tag (gtag.js) - Google Analytics -->
    <script async src="https://www.googletagmanager.com/gtag/js?id=G-J4XXF23R1V"></script>
    <script>
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          dataLayer.push(arguments);
        }
        gtag('js', new Date());
        gtag('config', 'G-J4XXF23R1V');
    </script>
  `);
}

export const FirebaseRemoteConfig = firebase.remoteConfig();
FirebaseRemoteConfig.defaultConfig = {
  // eslint-disable-next-line @typescript-eslint/camelcase
  newest_app_version: version,
};

Vue.config.productionTip = false;

Vue.use(VueFeather);
Vue.use(ElementUI);
Vue.use(ElementTiptapPlugin);

new Vue({
  render: h => h(App),
}).$mount('#app');
